import { createSelector } from "@reduxjs/toolkit";
import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const tooltipSelector = createSelector( 
  discoveryPanelsSelector,
  state => state.tooltip
);